import { useToast } from "./use-toast";
import { useEffect } from "react";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast";

export function Toaster() {
  const { toasts, dismiss } = useToast();

  // Auto-dismiss toasts after 2 seconds
  useEffect(() => {
    toasts.forEach((toast) => {
      if (toast.open) {
        const timer = setTimeout(() => {
          dismiss(toast.id);
        }, 2000);
        return () => clearTimeout(timer);
      }
    });
  }, [toasts, dismiss]);

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose onClick={() => dismiss(id)} />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
